// OK 17/10/2024

import { yupResolver } from "@hookform/resolvers/yup";
import { useContext } from "react";
import { useForm } from "react-hook-form";
import { Link, Outlet } from "react-router-dom";
import Menu from "../components/Menu/Menu";
import { AuthContext } from "../context";
import styles from "./Home.module.scss";
import * as yup from "yup";
import logo from "../assets/images/synergies2.svg";
import CalendarProvider from "../components/Calendar/CalendarProvider/CalendarProvider";
import logo_yellow from "../assets/images/logo_yellow.svg";

function Home() {
  const { user, signin, signout } = useContext(AuthContext);

  const validationSchema = yup.object({
    login: yup.string().required("Il faut préciser votre login"),
    password: yup
      .string()
      .required("Il faut préciser votre mot de passe")
      .min(3, "Mot de passe trop court"),
    generic: yup.string(),
  });

  const initialValues = {
    login: "",
    password: "",
    generic: "",
  };

  const {
    handleSubmit,
    register,
    formState: { errors, isSubmitting },
    setError,
    clearErrors,
  } = useForm({
    defaultValues: initialValues,
    resolver: yupResolver(validationSchema),
    mode: "onSubmit",
  });

  const submit = handleSubmit(async (credentials: any) => {
    try {
      clearErrors();
      await signin(credentials);
    } catch (error: any) {
      setError("generic", { type: "generic", message: error.message });
    }
  });

  return (
    <div>
      {user ? (
        <div className={` d-flex flex-column  ${styles.appContainer}`}>
          <header className={`d-flex align-items-center  ${styles.header}`}>
            <div className={styles.titleContainer}>
              <img className={styles.logo_yellow} src={logo_yellow}></img>
              <div className={styles.title}>SYNERGIES TECH</div>
            </div>
            <div className={styles.buttonContainer}>
              <Link to="/settings">
                <button className={`btnTd ${styles.buttonSettings}`}>
                  <i className={`fa-solid fa-gear ${styles.iLogout}`}></i>
                </button>
              </Link>
              <button
                className={`btnTd ${styles.buttonDecons}`}
                onClick={signout}
              >
                <i
                  className={`fa-solid fa-arrow-right-from-bracket ${styles.iLogout}`}
                ></i>
              </button>
            </div>
          </header>
          <div className={` d-flex flex-row ${styles.container} `}>
            <div className={`  ${styles.menu} `}>
              <Menu />
            </div>
            <div className={`  ${styles.body}`}>
              <CalendarProvider>
                <Outlet />
              </CalendarProvider>
            </div>
          </div>
        </div>
      ) : (
        <div
          className={` d-flex justify-content-center align-items-center ${styles.container} `}
        >
          <div>
            <img className={styles.logo} src={logo}></img>
          </div>
          <div
            className={` d-flex justify-content-center align-items-center ${styles.LoginContainer} `}
          >
            <form onSubmit={submit} className={styles.formLogin}>
              <div className={styles.titleLogin}>Connexion</div>
              <div className="mb-10 d-flex flex-column">
                <input
                  placeholder="Login"
                  type="text"
                  id="login"
                  {...register("login")}
                />
                {errors?.login && (
                  <p className="form-error">{errors.login.message}</p>
                )}
              </div>
              <div className="mb-10 d-flex flex-column">
                <input
                  placeholder="Mot de passe"
                  type="password"
                  id="password"
                  {...register("password")}
                />
                {errors?.password && (
                  <p className="form-error">{errors.password.message}</p>
                )}
              </div>
              {errors?.generic && (
                <div className="mb-10">
                  <p className="form-error">{errors.generic.message}</p>
                </div>
              )}
              <div className="d-flex justify-content-center">
                <button disabled={isSubmitting}>Connexion</button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
}

export default Home;
